import * as S from './styles'
import { useFooterContainer } from './useFooter'
import { LogoNhBlack } from '@/assets/logos'
import { Image, Text } from '@/components'

export const FooterLandingPage: React.FC = () => {
  const { footerData } = useFooterContainer()

  return (
    <S.FooterContainer>
      <Image src={LogoNhBlack} alt="logo Nata.House" />
      <Text size="h5" color="darkgray">
        {footerData.title}
      </Text>
    </S.FooterContainer>
  )
}
